<div mat-dialog-title>
  <h2>Confirm</h2>
</div>
<div mat-dialog-content>
  <div class="empathy-delete-question-dialog__content">
    <span class="fs__sm fw__500">
      {{ 'Are you sure you want to remove ' + (data.questionsCount === 1 ? 'this question?' : 'these ' + data.questionsCount + ' questions?') }}
    </span>

    @if (data.affectedQuestions?.size || data.affectedBlocks?.size) {
      <div class="empathy-delete-question-dialog__content__alert">
        <div class="empathy-delete-question-dialog__content__alert__header">
          <div class="empathy-delete-question-dialog__content__alert__header-icon">
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
          </div>
          <span class="fs__sm fw__600">Review impacted logic before deleting</span>
        </div>
        <ul class="empathy-delete-question-dialog__content__alert__info">
          @for (question of data.affectedQuestions; track question.id) {
            <li class="fs__sm fw__400">{{ question.code }}. {{ question.title | toPlainText }}</li>
          }

          @for (block of data.affectedBlocks; track block.id) {
            <li class="fs__sm fw__400">{{ block.id }}. {{ block.title | toPlainText }}</li>
          }
        </ul>
      </div>

      <div class="empathy-delete-question-dialog__content__warning">
        <fa-icon [icon]="faInfoCircle"></fa-icon>
        <span class="fs__sm fw__500">Deleting these questions will also remove related logic conditions.</span>
      </div>
    }
  </div>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Cancel</button>

  <button mat-flat-button [color]="'warn'" [mat-dialog-close]="true" cdkFocusInitial>Remove</button>
</div>
